// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** @deprecated: this file is about to be removed */
.n-table-head-cell {
  position: relative;
  padding: 0;
  font-weight: 600;
  font-family: 'IBM Plex Sans';
  line-height: inherit;
}
.n-table-head-cell--align-left {
  text-align: left;
}
.n-table-head-cell--align-center {
  text-align: center;
}
.n-table-head-cell--align-right {
  text-align: right;
}
.n-table-head-cell--with-actions .n-table-content--with-padding {
  padding-right: 17px;
}
.n-table-head-cell--draggable:hover::after {
  content: "";
  display: block;
  position: absolute;
  left: 10px;
  top: 5px;
  right: 25px;
  height: 6px;
  cursor: grab;
  border-top: 2px solid color-mix(in srgb, var(--color-content-secondary) 40%, transparent);
  border-bottom: 2px solid color-mix(in srgb, var(--color-content-secondary) 40%, transparent);
}
.n-table-head-cell--dropping-before::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: var(--color-accent-subtle-contrast);
}
.n-table-head-cell--dropping-after::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: var(--color-accent-subtle-contrast);
}
`, "",{"version":3,"sources":["webpack://./src/core-ui/components/table/TableHeadCell/TableHeadCell.less"],"names":[],"mappings":"AAAA,mDAAmD;AAEnD;EACE,kBAAA;EACA,UAAA;EAEA,gBAAA;EACA,4BAAA;EACA,oBAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,iBAAA;AAHJ;AAME;EAEI,mBAAA;AALN;AAUI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yFAAA;EACA,4FAAA;AARN;AAcM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;AAZR;AAgBM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;AAdR","sourcesContent":["@import \"~neptune-core-ui/less/variables.less\";\n\n.n-table-head-cell {\n  position: relative;\n  padding: 0;\n\n  font-weight: @font-weight-semibold;\n  font-family: @IBMPlexSans;\n  line-height: inherit;\n\n  &--align-left {\n    text-align: left;\n  }\n\n  &--align-center {\n    text-align: center;\n  }\n\n  &--align-right {\n    text-align: right;\n  }\n\n  &--with-actions {\n    .n-table-content--with-padding {\n      padding-right: 17px;\n    }\n  }\n\n  &--draggable {\n    &:hover::after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      left: 10px;\n      top: 5px;\n      right: 25px;\n      height: 6px;\n      cursor: grab;\n      border-top: 2px solid @TableAction-hover-color;\n      border-bottom: 2px solid @TableAction-hover-color;\n    }\n  }\n\n  &--dropping {\n    &-before {\n      &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        left: 0;\n        top: 0;\n        height: 100%;\n        width: 4px;\n        background: var(--color-accent-subtle-contrast);\n      }\n    }\n    &-after {\n      &::after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        right: 0;\n        top: 0;\n        height: 100%;\n        width: 4px;\n        background: var(--color-accent-subtle-contrast);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
